export const getStoredColumnsArray = (key: string) =>
  window.localStorage.getItem(key)?.split(",");

export const setLocalStorageColumns = (key: string, columns: string[]) =>
  window.localStorage.setItem(key, columns.join(","));
